import React from 'react';
import { useChatWidgetContext } from '../../ChatWidgetContext';
import styles from '../ChatWidget.module.scss';

export default function NewChatButton() {
  const { resetConversation, currentConversationId } = useChatWidgetContext();

  return (
    <button
      type="button"
      className={styles.headerButton}
      onClick={resetConversation}
      disabled={currentConversationId === null}
      aria-label="New chat"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 3V7C14 7.55228 14.4477 8 15 8H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5 8V5C5 3.89543 5.89543 3 7 3H14L19 8V19C19 20.1046 18.1046 21 17 21H7C5.89543 21 5 20.1046 5 19V16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3 12H13M13 12L10 9M13 12L10 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  );
}
